export default __webpack_public_path__ + "static/media/TeamExl.1ea03ccf.xlsx";